import styled from "styled-components";
import {MINI_ORBIT} from "../../../../../../../themes/css-global-classes";

export const LiveCasinoArenaNavbarButtonwrapperDefaultBox = styled.div`
  display: inline-block;
  margin: 0 0.1rem;
  padding: 1rem 0.5rem;

  &:first-child {
    margin-left: 0;
    padding-left: 0;
  }
  &:last-child {
    margin-right: 0;
    padding-right: 0;
  }

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding-top: 0.2rem;
    .${MINI_ORBIT} & {
      padding-bottom: 0.2rem;
    }
  }
`;
